
export default {
	EventType: 'eventType',
	NumberOfGames:'numberOfGames',
	NumberOfWeeks: 'numberOfWeeks',
	CertificationNumber: 'certificationNumber',
}


// WEBPACK FOOTER //
// ./src/containers/event/components/eventDetails/fields.js